export enum ReactAppErrorType {
  Redirect = 'Redirect',
  PageNotFound = 'PageNotFound',
  Unknown = 'Unknown',
}

export enum ReactAppNotFoundType {
  Primary = 0,
  Catalog = 1,
}

export interface IReactAppErrorProviders {
  app?: boolean;
  footer?: boolean;
  city?: string;
}

export interface IReactAppError {
  type: ReactAppErrorType;
  payload?: unknown;
  name?: string;
  message?: string;
  stack?: string;
  providers?: IReactAppErrorProviders;
}

export interface IErrorMeta {
  description?: string;
}

export interface IReactAppNotFoundProps {
  type?: ReactAppNotFoundType;
  status?: number;
  meta?: IErrorMeta;
  message?: string;
  providers?: IReactAppErrorProviders;
}

const initNotFoundOpts: IReactAppNotFoundProps = {
  type: ReactAppNotFoundType.Catalog,
};

export class ReactAppError extends Error implements IReactAppError {
  payload?: unknown;

  constructor(
    readonly type: ReactAppErrorType,
    message?: string,
  ) {
    super(message);
  }

  toJSON(): IReactAppError {
    const { type, message, name, stack, payload } = this;
    const providers =
      payload && typeof payload === 'object' && 'providers' in payload ? (payload.providers as IReactAppErrorProviders) : undefined;
    return { type, message, name, stack, payload, providers };
  }
}

export class ReactAppRedirectError extends ReactAppError {
  constructor(location: string, message?: string) {
    super(ReactAppErrorType.Redirect, message);
    this.payload = location;
  }
}

export class ReactAppPageNotFoundError extends ReactAppError {
  constructor(opts?: IReactAppNotFoundProps) {
    const { message, ...payload } = { ...initNotFoundOpts, ...opts };
    super(ReactAppErrorType.PageNotFound, message);
    this.payload = payload;
  }
}

export class ReactAppUnknownError extends ReactAppError {
  constructor(errorOrMessage?: unknown) {
    super(ReactAppErrorType.Unknown);

    if (errorOrMessage) {
      if (errorOrMessage instanceof Error) {
        this.message = errorOrMessage.message;
        this.name = errorOrMessage.name;
        this.stack = errorOrMessage.stack;
      } else if (typeof errorOrMessage === 'object') {
        try {
          this.message = JSON.stringify(errorOrMessage);
        } catch {}
      } else {
        this.message = String(errorOrMessage);
      }
    }
  }
}
